<template>
  <div>
    <div
      class="mt-3 mb-4 field-of-fields"
      style="width: 75%; display: block; margin-left: auto; margin-right: auto;"
    >
      <a :href="$store.getters.website">
        <img
          :src="require(`../../assets/img/logo/${$store.getters.logo}`)"
          width=""
          :height="$store.getters.logoHeight"
          :alt="$store.getters.agencyHumanName"
          style=""
          id=""
          class="center"
        />
      </a>
      <h1 class="center mt-5">Tiny Treasures Candidate Application</h1>
      <p class="center mb-4 form-note">
        Please note that we encourage our clients to pay nannies on the books
        and legally. You must be comfortable with this to be considered as a
        candidate of TTNA.
      </p>

      <hr />
      <h3 style="">Personal Information</h3>
      <p class="text-require-notice">Fields marked with an * are required</p>
      <FormGroupRowLayout
        :listFields="$store.getters.candidatePersonalInfoListFields"
        :modelData="applicationData"
        :submitClicked="submitClicked"
      />

      <hr />
      <h3 style="">References</h3>
      <p class="text-require-notice">
        You must enter at least 3 references. They will be contacted after your
        interview with us.
      </p>
      <button
        class="mylisting-button dark-button mt-3 mb-3"
        @click="showAddReferenceDialog()"
      >
        Add Reference
      </button>
      <div v-for="(reference, index) of listReferences" :key="'ref' + index">
        <hr class="ref-separator" />
        <h5 style="font-weight: 600; margin-bottom: 0;">
          {{ reference.name }}
          <img
            class="edit-button"
            src="../../assets/img/icons/edit_icon_simple.svg"
            @click="showEditReferenceDialog(reference, index)"
          />
        </h5>
        <DetailSectionColumnLayout
          :itemPerColumns="[5, 4]"
          :modelData="reference"
          :listFields="$store.getters.referenceListFields"
          :listExcludeFields="['name']"
        />
      </div>
      <hr />
      <h3 style="">Documents</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;" />

      <label style="margin-bottom: 4px;"
        >Please upload your professional childcare resume! (PDF or Word doc only please!) *
      </label>
      <input
        type="file"
        class="form-control-file"
        ref="resume"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-on:change="handleUploadResume()"
      />

      <label style="margin-bottom: 4px;"
        >Please upload a recent photo of yourself! (PNG or JPG only please!) *
      </label>
      <input
        type="file"
        class="form-control-file"
        ref="profile_pic"
        accept="image/x-png,image/jpeg"
        v-on:change="handleUploadProfilePhoto()"
      />
      <hr />
      <p class="privacy-note">
        Many of Tiny Treasures’ clients are prominent, well-known individuals in
        the US. Their privacy is very important to them. Tiny Treasures may
        require you as the candidate to sign a confidentiality form during the
        interview process. Any job that Tiny Treasures places me on will be held
        in the strictest confidence. This includes personal family matters as
        well as the names, addresses and/or telephone numbers of family members.
      </p>
      <p class="referral-service-note">
        REFERRAL SERVICE: THERE IS ABSOLUTELY NO FEE TO BE A TINY TREASURES
        CANDIDATE. APPLICANT UNDERSTANDS AND AGREES THAT TINY TREASURES IS
        ACTING AS A REFERRAL SERVICE ONLY AND THE DECISION TO EMPLOY YOU IS FROM
        TINY TREASURES CLIENT SEEKING HOUSEHOLD STAFFING SERVICES. APPLICANT
        UNDERSTANDS AND AGREES THAT TINY TREASURES DOES NOT GUARANTEE
        APPLICANT'S REFERRAL, PLACEMENT, EMPLOYMENT, COMPENSATION, OR TERMS OF
        EMPLOYMENT.
      </p>
      <div class="submit-button-section">
        <button
          class="mylisting-button dark-button"
          @click="submitApplication()"
        >
          Submit
        </button>
      </div>
    </div>
    <ReferenceFormDialog
      v-model="isShowReferenceFormDialog"
      :reference="reference"
      :isAdd="isAddReferenceDialog"
      @saved="handleUpdateReferences($event)"
    />
  </div>
</template>

<script>
import axios from "axios";
import FormGroupRowLayout from "../common/FormGroupRowLayout";
import ReferenceFormDialog from "./dialogs/ReferenceFormDialog";
import DetailSectionColumnLayout from "../common/DetailSectionColumnLayout";
import { ACTION_TYPE } from "../../constants/custom-define-type";

export default {
  components: {
    FormGroupRowLayout,
    ReferenceFormDialog,
    DetailSectionColumnLayout
  },
  data() {
    return {
      submitClicked: false,
      applicationData: {},
      isShowReferenceFormDialog: false,
      reference: {},
      listReferences: [],
      isAddReferenceDialog: false,
      resume: null,
      profilePic: null,
      numberSubmitSuccess: 0,
      indexOfEdittingRef: 0
    };
  },
  created() {
    window.location.href = 'https://agency.enginehire.io/application-form/33/432';
  },
  methods: {
    showAddReferenceDialog() {
      this.isAddReferenceDialog = true;
      this.reference = {};
      this.isShowReferenceFormDialog = true;
    },
    showEditReferenceDialog(ref, index) {
      this.indexOfEdittingRef = index;
      this.isAddReferenceDialog = false;
      this.reference = { ...ref };
      this.isShowReferenceFormDialog = true;
    },
    handleUpdateReferences(actionType) {
      if (actionType === ACTION_TYPE.ADD) {
        this.listReferences.push({ ...this.reference, id: 0 });
      } else if (actionType === ACTION_TYPE.UPDATE) {
        this.listReferences[this.indexOfEdittingRef] = this.reference;
      } else if (actionType === ACTION_TYPE.DELETE) {
        this.listReferences.splice(this.indexOfEdittingRef, 1);
      }
    },
    handleUploadResume() {
      this.resume = this.$refs.resume.files[0];
      if (this.resume) {
        if (
          !this.$store.getters.acceptResumeType.includes(this.resume["type"])
        ) {
          this.resume = null;
          this.$refs.resume.value = "";
          this.showErrorDialog(this.$store.getters.invalidResumeFileError);
        }
      }
    },
    handleUploadProfilePhoto() {
      this.profilePic = this.$refs.profile_pic.files[0];
      if (this.profilePic) {
        if (
          !this.$store.getters.acceptedImageTypes.includes(
            this.profilePic["type"]
          )
        ) {
          this.profilePic = null;
          this.$refs.profile_pic.value = "";
          this.showErrorDialog(this.$store.getters.invalidImageFileError);
        }
      }
    },
    submitApplication() {
      this.submitClicked = true;
      if (
        this.hasInvalidField(
          this.applicationData,
          this.$store.getters.candidatePersonalInfoListFields
        )
      ) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        window.scroll(0, 0); // Scroll the window up so they have to scroll down the application to see what's missing
      } else if (this.listReferences.length < 3) {
        this.showErrorDialog(this.$store.getters.missingReferenceError);
      } else if (this.resume == null) {
        this.showErrorDialog(this.$store.getters.missingResumeError);
      } else if (this.profilePic == null) {
        this.showErrorDialog(this.$store.getters.missingProfilePictureError);
      } else {
        this.registerUser();
      }
    },
    registerUser() {
      this.$store
        .dispatch("registerUser", {
          email: this.applicationData.email,
          password: this.applicationData.email,
          user_type: "candidate",
          status: "Applied",
          phone: this.applicationData.phone
        })
        .then(() => {
          this.patchDetails();

          // Send myself an email notification that a new client started a quote
          this.$store.dispatch("sendEmails", {
            subject: "New Nanny Application",
            message:
              "New nanny application form submitted by: " +
              this.applicationData.first_name +
              " " +
              this.applicationData.last_name +
              " | " +
              this.applicationData.email +
              "\nPlease log into the administrator dashboard to view it!",
            from: this.$store.getters.agencyFromEmail,
            emails: [
              this.$store.getters.enginehireLoggingEmail,
              this.$store.getters.agencyAdminEmail2
            ],
            reply: this.$store.getters.agencyReplyEmail,
            userID: 4
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    patchDetails() {
      axios
        .patch(
          "/api/people/" + this.$store.getters.userID.toString() + "/",
          this.applicationData
        )
        .then(res => {
          console.log(res);
          this.showResultDialog(this.$store.getters.submitSuccess);
          this.uploadDocument();
          for (const ref of this.listReferences) {
            this.postReference(ref);
          }

          // Send applicant a confirmation email
          this.$store.dispatch("sendEmails", {
            subject: "We have received your application",
            message:
              "Hi " +
              this.applicationData.first_name +
              ", \n\n" +
              "Thank you for your application to join the TinyTreasureNYC Family!\n" +
              "We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the nannies we select. Thanks for your understanding!\n\n" +
              "Sincerely,\nThe TinyTreasureNYC Team",
            from: this.$store.getters.agencyFromEmail,
            emails: [
              this.$store.getters.enginehireLoggingEmail,
              this.applicationData.email
            ],
            reply: this.$store.getters.agencyReplyEmail,
            userID: this.$store.getters.userID
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    uploadDocument() {
      const formData = new FormData();
      if (this.profilePic) {
        formData.append("profile_pic", this.profilePic);
      }
      if (this.resume) {
        formData.append("resume", this.resume);
      }
      axios
        .patch(
          "/api/people/" + this.$store.getters.userID.toString() + "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(res => {
          this.numberSubmitSuccess += 1;
          this.handleSubmittedReference();
        })
        .catch(error => {
          console.log(error);
        });
    },
    postReference(reference) {
      axios
        .post("/api/references/", {
          ...reference,
          user: this.$store.getters.userID,
          agency: this.$store.getters.agencyID,
          agency_owner: this.$store.getters.agencyName
        })
        .then(res => {
          this.numberSubmitSuccess += 1;
          this.handleSubmittedReference();
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSubmittedReference() {
      if (this.numberSubmitSuccess === this.listReferences.length + 1) {
        // this.showResultDialog(this.$store.getters.submitSuccess);
      }
    }
  }
};
</script>

<style>
.form-note {
  font-weight: 500;
}

.ref-separator {
  margin: 1rem;
}

.privacy-note {
  margin: 1rem 0;
}

.referral-service-note {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/candidates/ApplicationForm.vue